import { render } from "./Trend7.0.vue?vue&type=template&id=30597ca8&scoped=true&ts=true"
import script from "./Trend7.0.vue?vue&type=script&lang=ts"
export * from "./Trend7.0.vue?vue&type=script&lang=ts"

import "./Trend7.0.vue?vue&type=style&index=0&id=30597ca8&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30597ca8"]])

export default __exports__